import { ActionContext } from 'vuex';

import { getLocalState } from '@/common/utils/store';

import { VED_COMMON_ACTIONS_NAME, VED_COMMON_MUTATIONS_NAME } from './name';
import { TVedCommonState } from './types';

import links from '@/utils/links';
import request from '@/utils/request';

export async function searchCountriesTree(context: ActionContext<TVedCommonState, unknown>) {
  return request(
    context,
    {
      url: links.ved.common.getCountriesTree,
      mutate: getLocalState(VED_COMMON_MUTATIONS_NAME.setCountriesTree),
      name: getLocalState(VED_COMMON_ACTIONS_NAME.searchCountriesTree),
    },
    {},
  );
}

export async function searchRegionsRfTree(context: ActionContext<TVedCommonState, unknown>) {
  return request(
    context,
    {
      url: links.ved.common.getRegionsRfTree,
      mutate: getLocalState(VED_COMMON_MUTATIONS_NAME.setRegionsRfTree),
      name: getLocalState(VED_COMMON_ACTIONS_NAME.searchRegionsRfTree),
    },
    {},
  );
}

export async function searchCustomsOrgansOnBorder(context: ActionContext<TVedCommonState, unknown>) {
  return request(
    context,
    {
      url: links.ved.common.getCustomsOrgansOnBorder,
      mutate: getLocalState(VED_COMMON_MUTATIONS_NAME.setCustomsOrgansOnBorder),
      name: getLocalState(VED_COMMON_ACTIONS_NAME.searchCustomsOrgansOnBorder),
    },
    {},
  );
}

export async function searchCustomsOrgansOnBorderTree(context: ActionContext<TVedCommonState, unknown>) {
  await request(
    context,
    {
      url: links.ved.common.getTCustDepartmentTree,
      mutate: getLocalState(VED_COMMON_MUTATIONS_NAME.setCustomsOrgansOnBorderTree),
      name: getLocalState(VED_COMMON_ACTIONS_NAME.searchCustomsOrgansOnBorderTree),
    },
    {},
  );
  return context.state.customsOrgansOnBorderTree;
}
